/* eslint-disable jsx-a11y/heading-has-content */
import * as React from "react";
import { cn } from "src/lib/utils";

const MainCard = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "max-w-6xl mx-auto p-6 border rounded-md bg-[#f8f9fa]",
      className
    )}
    {...props}
  />
));
MainCard.displayName = "MainCard";

const MainCardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn("text-xl mb-6 text-primary font-bold", className)}
    {...props}
  />
));
MainCardTitle.displayName = "MainCardTitle";

const MainCardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("grid md:grid-cols-2 gap-6 mb-6 grid-cols-1", className)}
    {...props}
  />
));
MainCardContent.displayName = "MainCardContent";

const MainCardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("flex justify-between", className)} {...props} />
));
MainCardFooter.displayName = "MainCardFooter";

export { MainCard, MainCardContent, MainCardFooter, MainCardTitle };

